import React from 'react'
import {
  BoldMark,
  ItalicMark,
  UnderlinedMark,
  HighlightMark,
  ParagraphLeftBlock,
  ParagraphCenterBlock,
  ParagraphRightBlock,
  BulletedListBlock,
  NumberedListBlock,
  ListItemBlock,
  LinkMark,
  LinkTextMark
} from './Elements'
import IconBold from 'components/Icons/IconBold'
import IconItalic from 'components/Icons/IconItalic'
import IconUnderlined from 'components/Icons/IconUnderlined'
import IconNumberedList from 'components/Icons/IconNumberedList'
import IconBulletedList from 'components/Icons/IconBulletedList'
import IconLink from 'components/Icons/IconLink'
import IconAlignLeft from 'components/Icons/IconAlignLeft'
import IconAlignCenter from 'components/Icons/IconAlignCenter'
import IconAlignRight from 'components/Icons/IconAlignRight'
import * as C from './constants'
import { createUrl } from '@jarvis.oddle/core/tools/routes'
import {
  borderRadius,
  borderRadiusSizes
} from 'theme/default'

export const markConfig = {
  [C.BOLD]: (children) => <BoldMark children={children} />,
  [C.ITALIC]: (children) => <ItalicMark children={children} />,
  [C.UNDERLINED]: (children) => <UnderlinedMark children={children} />,
  [C.HIGHLIGHT]: (children) => <HighlightMark children={children} />
}

export const blockConfig = {
  [C.PARAGRAPH]: (children) => <ParagraphLeftBlock children={children} />,
  [C.PARAGRAPH_CENTER]: (children) => <ParagraphCenterBlock children={children} />,
  [C.PARAGRAPH_RIGHT]: (children) => <ParagraphRightBlock children={children} />,
  [C.BULLETED_LIST]: (children) => <BulletedListBlock children={children} />,
  [C.NUMBERED_LIST]: (children) => <NumberedListBlock children={children} />,
  [C.LIST_ITEM]: (children) => <ListItemBlock children={children} />,
  [C.LINK]: (children, node) => {
    const href = createUrl(node.data.get('href'))
    return (
      <LinkMark href={href}>
        <LinkTextMark children={children} />
      </LinkMark>
    )
  }
}

export const tagConfig = {
  b: { type: C.BOLD, group: C.MARK },
  i: { type: C.ITALIC, group: C.MARK },
  u: { type: C.UNDERLINED, group: C.MARK },
  ul: { type: C.BULLETED_LIST, group: C.BLOCK },
  ol: { type: C.NUMBERED_LIST, group: C.BLOCK },
  li: { type: C.LIST_ITEM, group: C.BLOCK },
  a: { type: C.LINK, group: C.INLINE },
  p: {
    type: C.PARAGRAPH,
    group: C.BLOCK,
    variants: {
      [C.PARAGRAPH]: { type: C.PARAGRAPH, group: C.BLOCK },
      [C.PARAGRAPH_CENTER]: { type: C.PARAGRAPH_CENTER, group: C.BLOCK },
      [C.PARAGRAPH_RIGHT]: { type: C.PARAGRAPH_RIGHT, group: C.BLOCK }
    }
  },
  [C.SEPERATOR]: { type: C.SEPERATOR, group: C.SEPERATOR }
}

export const borderConfig = {
  [C.BORDER_NONE]: `${borderRadius[borderRadiusSizes.none]}`,
  [C.BORDER_LEFT]: `${borderRadius[borderRadiusSizes.small]}
                    ${borderRadius[borderRadiusSizes.none]}
                    ${borderRadius[borderRadiusSizes.none]}
                    ${borderRadius[borderRadiusSizes.small]}`,
  [C.BORDER_RIGHT]: `${borderRadius[borderRadiusSizes.none]}
                    ${borderRadius[borderRadiusSizes.small]}
                    ${borderRadius[borderRadiusSizes.small]}
                    ${borderRadius[borderRadiusSizes.none]}`,
  [C.BORDER_BOTH]: `${borderRadius[borderRadiusSizes.small]}`
}

export const toolbarConfig = [
  { tag: tagConfig.b, icon: IconBold, border: C.BORDER_LEFT },
  { tag: tagConfig.i, icon: IconItalic, border: C.BORDER_NONE },
  { tag: tagConfig.u, icon: IconUnderlined, border: C.BORDER_RIGHT },
  { tag: tagConfig[C.SEPERATOR], icon: null, border: C.BORDER_NONE },
  { tag: tagConfig.ol, icon: IconNumberedList, border: C.BORDER_LEFT },
  { tag: tagConfig.ul, icon: IconBulletedList, border: C.BORDER_RIGHT },
  { tag: tagConfig[C.SEPERATOR], icon: null, border: C.BORDER_NONE },
  { tag: tagConfig.a, icon: IconLink, border: C.BORDER_BOTH },
  { tag: tagConfig.p.variants[C.PARAGRAPH], icon: IconAlignLeft, border: C.BORDER_LEFT },
  { tag: tagConfig.p.variants[C.PARAGRAPH_CENTER], icon: IconAlignCenter, border: C.BORDER_NONE },
  { tag: tagConfig.p.variants[C.PARAGRAPH_RIGHT], icon: IconAlignRight, border: C.BORDER_RIGHT }
]

export const getToolbarConfig = (mode) => {
  switch (mode) {
    case C.COMPACT_MODE:
      return [
        { tag: tagConfig.b, icon: IconBold, border: C.BORDER_LEFT },
        { tag: tagConfig.i, icon: IconItalic, border: C.BORDER_NONE },
        { tag: tagConfig.u, icon: IconUnderlined, border: C.BORDER_RIGHT },
        { tag: tagConfig[C.SEPERATOR], icon: null, border: C.BORDER_NONE },
        { tag: tagConfig.a, icon: IconLink, border: C.BORDER_BOTH }
      ]

    case C.COMPLETE_MODE:
    default:
      return toolbarConfig
  }
}
